/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function RobloxLogo(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 116 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162864)">
        <path
          d="M13.9646 27.2098L17.2988 33.3119H11.1124L8.29729 28.0971H5.6303V33.3119H0V14.8264H10.2975C14.5572 14.8264 17.2617 17.1906 17.2617 21.4423C17.2617 24.1781 16.0022 26.138 13.9646 27.2098ZM5.6303 19.6307V23.2908H9.63077C10.8161 23.2908 11.5569 22.5884 11.5569 21.4423C11.5569 20.2961 10.8161 19.6307 9.63077 19.6307H5.6303ZM35.1898 34.6784L18.3359 30.1309L22.855 13.3086L31.2818 15.5823L39.7087 17.856L35.1898 34.6784ZM32.0042 22.2926L27.2999 20.9986L26.0405 25.6939L30.7448 26.9883L32.0042 22.2926ZM59.0078 28.0971C59.0078 31.6462 56.7482 33.3119 53.2293 33.3119H42.191V14.8264H52.8589C56.3778 14.8264 58.6374 16.6379 58.6374 19.8175C58.6374 21.8139 57.8965 23.1453 56.4889 24.0695C58.0817 24.7697 59.0078 26.1749 59.0078 28.0971ZM47.6731 19.2629V21.9988H51.3382C52.3384 21.9988 52.931 21.5551 52.931 20.5939C52.931 19.7066 52.3384 19.2629 51.3382 19.2629H47.6731ZM47.6731 28.8754H51.7847C52.7477 28.8754 53.3053 28.3578 53.3053 27.4701C53.3053 26.5092 52.7498 26.0656 51.7847 26.0656H47.6731V28.8754ZM61.7859 14.8264H67.4154V27.8386H75.4904V33.3119H61.7851L61.7859 14.8264ZM96.1978 24.0695C96.1978 25.9707 95.633 27.8292 94.5747 29.41C93.5164 30.9908 92.0123 32.2228 90.2525 32.9503C88.4928 33.6779 86.5564 33.8683 84.6882 33.4973C82.82 33.1264 81.104 32.2109 79.757 30.8666C78.4102 29.5222 77.4928 27.8095 77.1213 25.9448C76.7496 24.0802 76.9404 22.1474 77.6693 20.391C78.3983 18.6345 79.6326 17.1333 81.2165 16.077C82.8001 15.0208 84.6623 14.457 86.5669 14.457C87.8322 14.4545 89.0855 14.7014 90.2551 15.1834C91.4246 15.6655 92.4872 16.3733 93.382 17.2662C94.2767 18.1591 94.9861 19.2195 95.4692 20.3867C95.9525 21.5538 96.2 22.8047 96.1978 24.0676V24.0695ZM90.5674 24.0695C90.5674 21.7769 88.7524 19.9654 86.5669 19.9654C84.3815 19.9654 82.5662 21.7769 82.5662 24.0695C82.5662 26.3621 84.3815 28.1734 86.5669 28.1734C88.7524 28.1734 90.5674 26.3594 90.5674 24.0676V24.0695ZM109.755 23.7734L115.83 33.3119H109.124L105.792 27.8752L102.347 33.3119H95.531L101.865 23.9948L96.0497 14.8264H102.754L105.828 19.8175L108.792 14.8264H115.459L109.755 23.7734Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_18442_162864">
          <rect
            width="115.83"
            height="21.4286"
            fill="white"
            transform="translate(0 13.3086)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

RobloxLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default RobloxLogo
